export const OAUTH_URL = '/security/v2/oauth';
export const ACCOUNT_URL = '/security/v2/account';
export const IDENTITY_URL = '/security/v2/identity';
export const MODULES_URL = '/security/v2/modules';
